import type { SVGProps } from 'react';

// Small chat avatar: a tight head crop of the real Rishi illustration (brand/logos-rishi),
// replacing the old hand-drawn SVG face crop. Decorative (alt="") by default — repeated once per
// message, where the surrounding text already identifies the speaker; the one-per-page header
// avatar passes a real alt instead.
export function RishiAvatar({ className = '', alt = '' }: { className?: string; alt?: string }) {
  return (
    <img
      className={className}
      src="/brand/rishi-avatar.png"
      width={42}
      height={42}
      alt={alt}
      loading="lazy"
    />
  );
}

// Small spiritual icons for the hero.
type IconProps = SVGProps<SVGSVGElement>;

export const Diya = (p: IconProps) => (
  <svg viewBox="0 0 64 64" {...p}>
    <path d="M32 6 C38 16 40 22 32 30 C24 22 26 16 32 6Z" fill="#ffcf5a" />
    <path d="M32 14 C35 19 35 23 32 26 C29 23 29 19 32 14Z" fill="#fff4c8" />
    <path d="M8 36 Q32 30 56 36 Q50 54 32 54 Q14 54 8 36Z" fill="#e0822e" />
    <path d="M8 36 Q32 42 56 36" stroke="#b9531a" strokeWidth="2" fill="none" />
  </svg>
);
export const Lotus = (p: IconProps) => (
  <svg viewBox="0 0 64 64" {...p}>
    <g fill="#f3a6bb" stroke="#ffd46b" strokeWidth="1.2">
      <path d="M32 12 C40 22 40 36 32 46 C24 36 24 22 32 12Z" />
      <path d="M14 24 C26 26 32 36 32 46 C22 44 14 36 14 24Z" />
      <path d="M50 24 C38 26 32 36 32 46 C42 44 50 36 50 24Z" />
    </g>
    <path d="M8 46 Q32 56 56 46" stroke="#ffd46b" strokeWidth="2" fill="none" />
  </svg>
);
export const Moon = (p: IconProps) => (
  <svg viewBox="0 0 64 64" {...p}>
    <path d="M40 8 A24 24 0 1 0 56 44 A20 20 0 1 1 40 8Z" fill="#ffe7a3" />
  </svg>
);
export const Sparkle = (p: IconProps) => (
  <svg viewBox="0 0 64 64" {...p}>
    <path d="M32 4 L37 27 L60 32 L37 37 L32 60 L27 37 L4 32 L27 27Z" fill="#ffe7a3" />
  </svg>
);
export const Kalash = (p: IconProps) => (
  <svg viewBox="0 0 64 64" {...p}>
    <path d="M22 10 Q32 4 42 10 L38 18 L26 18Z" fill="#6fbf73" />
    <ellipse cx="32" cy="20" rx="10" ry="3" fill="#f0b43c" />
    <path d="M20 24 Q32 18 44 24 Q56 40 40 54 L24 54 Q8 40 20 24Z" fill="#f0b43c" />
    <path d="M18 34 Q32 40 46 34" stroke="#c9621c" strokeWidth="2.5" fill="none" />
    <circle cx="32" cy="30" r="3" fill="#e0443a" />
  </svg>
);
